import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Row, Col} from 'react-bootstrap'
import {loadPageContent} from '../../../../actions/content';

class TextViewer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.dispatch(loadPageContent(`api/pages/${this.props.pageSlug}`));
    }

    render() {
        if (this.props.contents[`${this.props.pageSlug}_content_text`]) {
            return (
                <Row>
                    <Col lg={12}>
                        <div dangerouslySetInnerHTML={{__html: this.props.contents[`${this.props.pageSlug}_content_text`].body}}/>
                    </Col>
                </Row>
            );
        }
        return null;
    }
};

const mapStateToProps = (state) => {
    return {
      contents: state.content.list,
    };
};

export default connect(mapStateToProps)(TextViewer);



// WEBPACK FOOTER //
// ./src/components/common/editor/text-viewer/index.jsx